import { getBoardUsers } from "../services/apiBoards";
import {
  getBoardUser,
  getCustomFields,
  getLdapUserList,
  getUser,
  getUserDetailByToken,
  getUserProfileForAdmin,
  getUsers,
  getWatchlist,
  getWatchlistUsers,
} from "../services/apiUser";
import { hasAllQueryValues, hasQueryValue, useMappedQuery } from "./queryUtils";

export function useUsers() {
  return useMappedQuery({
    queryKey: ["users"],
    queryFn: getUsers,
    dataKey: "users",
  });
}

export function useBoardUsers(id) {
  return useMappedQuery({
    queryKey: ["boardUsers", id],
    queryFn: () => getBoardUsers(id),
    enabled: hasQueryValue(id),
  });
}

export function useLoginUser(id) {
  return useMappedQuery({
    queryKey: ["me"],
    queryFn: () => getUser(id),
  });
}

export function useInternalLdapUser() {
  return useMappedQuery({
    queryKey: ["LDAPinternalList"],
    queryFn: getLdapUserList,
  });
}

export function useWatching(id) {
  return useMappedQuery({
    queryKey: ["watching", id],
    queryFn: () => getWatchlist(id),
    enabled: hasQueryValue(id),
  });
}

export function useWatchlistUsers() {
  return useMappedQuery({
    queryKey: ["watchlistUsers"],
    queryFn: getWatchlistUsers,
  });
}

export function useUserData(token) {
  return useMappedQuery({
    queryKey: ["user-data"],
    queryFn: () => getUserDetailByToken(token),
    enabled: hasQueryValue(token),
    retry: false,
  });
}

export function useUserProfileForAdmin(id) {
  const { isLoading, data, error, isError } = useMappedQuery({
    queryKey: ["userProfile", id],
    queryFn: () => getUserProfileForAdmin(id),
  });

  return {
    isLoading,
    error,
    profileData: data?.data?.data?.responseData,
    isError,
  };
}

export function useGetBoardUser(boardId, userId) {
  return useMappedQuery({
    queryKey: ["boardUser", userId],
    queryFn: () => getBoardUser(boardId, userId),
    enabled: hasAllQueryValues(boardId, userId),
  });
}

export function useGetBoardDynamicFields(boardId) {
  const { data, isLoading, isRefetching } = useMappedQuery({
    queryKey: ["getCustomFields", boardId],
    queryFn: () => getCustomFields(boardId),
  });

  return { data, isLoading, isRefetching };
}
